// The best-effort service worker (spec FE-09): registered after the page has loaded, in a built
// client only. Inside the Lagos Life frame the browser may refuse it (a third-party frame, storage
// blocked or purged): then nothing happens and HTTP caching alone carries the second load. No
// install prompt, no wake lock, no update banner: a new worker just takes over quietly.
export function registerServiceWorker(): void {
  try {
    if (!import.meta.env.PROD) return;
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    const go = () => {
      try {
        navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => undefined);
      } catch {
        // refused in this frame
      }
    };
    // after the load event, so it never competes with the menu for the network
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  } catch {
    // reading navigator.serviceWorker can throw in a sandboxed frame
  }
}
